import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import ServiceChildSponsors from '../../components/ServiceChildSponsors'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'


const ServiceChildSponsorsPage =() => {
    return(
        <Fragment>
            <Navbar/>
            <PageTitle pageTitle={'Service'} pagesub={'Service'}/>
            <ServiceChildSponsors/>
            <Footer footerClass={'wpo-ne-footer-2'}/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ServiceChildSponsorsPage;
